export default {
  //#region 登录
  login: {
    username: "请输入账号",
    password: "请输入密码",
    login: "立即登录",
    Switch_to_Chinese: "切换中文",
    Switch_to_English: "切换英文",
  },
  //#endregion

  //#region 顶部状态栏
  topbar: {
    我的主页: "我的主页",
    控制台: "控制台",
    项目主页: "项目主页",
    项目设置: "项目设置",
    项目: "项目",
    公司: "公司",
  },

  //#endregion

  //#region 我的主页
  我的主页: {
    全部: "全部",
    我加入的: "我加入的",
    我管理的: "我管理的",
    请输入项目名称: "请输入项目名称",
    按时间排序: "按时间排序",
    按合同排序: "按合同排序",
    按规模排序: "按规模排序",
    按人力排序: "按人力排序",
    管理: "管理",
    协作: "协作",
    最近打开的文件: "最近打开的文件",
  },
  //#endregion

  //#region  项目设置控制台
  项目设置侧边栏: {
    项目信息: "项目信息",
    通知管理: "通知管理",
    应用导航: "应用导航",
    成员管理: "成员管理",
    岗位权限: "岗位权限",
    资料管理: "资料管理",
    进度状态设置: "进度状态设置",
    工程动态设置: "工程动态设置",
    话题讨论标签: "话题讨论标签",
    工单标签设置: "工单标签设置",
    实景标签设置: "实景标签设置",
  },
  通知管理: {
    通知管理: "通知管理",
    序号: "序号",
    名称: "名称",
    发布者: "发布者",
    更新时间: "更新时间",
    操作: "操作",
    新建通知: "新建通知",
    时间: "时间",
    标题颜色: "标题颜色",
    内容: "内容",
    编辑公告信息: "编辑公告信息",
    排序: "排序",
  },
  作业面: {
    作业面维护: "作业面维护",
    关联: "关联",
    序号: "序号",
    模型名称: "模型名称",
    选择集名称: "关联集名称",
    版本备注: "版本备注",
    更新时间: "更新时间",
    模型选择集: "模型选择集",
    注意:
      "请注意，类型为单模或选择集时，只能选择一个模型;为合模时支持多个合并加载。保存视点和选择集操作只对单模型类型可用。",
    单模: "单模",
    选择集: "选择集",
    合模: "合模",
  },
  成员管理: {
    成员管理: "成员管理",
    显示全部成员: "显示全部成员",
    请输入用户姓名: "请输入用户姓名",
    邀请: "邀请",
    导出: "导出",
    移除: "移除",
    账号: "账号",
    姓名: "姓名",
    性别: "性别",
    组织机构: "组织机构",
    岗位: "岗位",
    邮箱: "邮箱",
    手机号: "手机号",
    状态: "状态",
    操作: "操作",
    查看: "查看",
    查看成员: "查看成员",
    编辑成员: "编辑成员",
    请选择组织: "请选择组织",
    请选择岗位: "请选择岗位",
    选择邀请账号信息: "请选择邀请账号信息",
    地址: "地址",
  },
  岗位权限: {
    岗位权限: "岗位权限",
    重命名: "重命名",
    复制: "复制",
    权限: "权限",
    移除岗位: "移除岗位",
    添加岗位: "添加岗位",
    岗位名称: "岗位名称",
    权限管理: "权限管理",
    项目管理: "项目管理",
    团队成员: "团队成员",
    电话加密: "电话加密",
    邮箱加密: "邮箱加密",
    使用话题讨论: "使用话题讨论",
    协作沟通: "协作沟通",
    使用工单任务: "使用工单任务",
    发起任务: "发起任务",
    进度管理: "进度管理",
    三维模拟: "三维模拟",
    进度计划: "进度计划",
    新建: "新建",
    删除: "删除",
    进度展示: "进度展示",
    查看: "查看",
    编辑: "编辑",
    资料管理: "资料管理",
    分享: "分享",
    查看关联: "查看关联",
    下载: "下载",
    图纸管理: "图纸管理",
    条码管理: "条码管理",
    生成: "生成",
    打印: "打印",
    实景管理: "实景管理",
    上传: "上传",
    请输入岗位名称: "请输入岗位名称",
    账号: "账号",
    姓名: "姓名",
    组织机构: "组织机构",
    岗位: "岗位",
    邮箱: "邮箱",
    手机号: "手机号",
    操作: "操作",
  },
  资料管理: {
    资料管理: "资料管理",
    资料目录树: "资料目录树",
    资料目录导入: "资料目录导入",
    资料目录导出: "资料目录导出",
    设置: "设置",
    资料标签: "资料标签",
    显示全部人员: "显示全部人员",
    当前节点是否需要审核: "当前节点是否需要审核",
    是: "是",
    否: "否",
    已选择人员: "已选择人员",
    提交: "提交",
    序号: "序号",
    账号: "账号",
    姓名: "姓名",
    所属组织: "所属组织",
    岗位: "岗位",
    邮箱: "邮箱",
    手机号: "手机号",
    名称: "名称",
    文件数量: "文件数量",
    维护人员: "维护人员",
    更新时间: "更新时间",
    设置可见人员审核: "设置可见人员/审核",
    不选择为全部可见: "不选择为全部可见",
  },
  进度状态设置: {
    进度状态设置: "进度状态设置",
    排序: "排序",
    状态名称: "状态名称",
    颜色: "颜色",
    更新时间: "更新时间",
    操作: "操作",
    设置进度状态: "设置进度状态",
  },
  工程动态标签: {
    工程动态标签: "工程动态标签",
    序号: "序号",
    名称: "名称",
    更新时间: "更新时间",
    操作: "操作",
    重命名: "重命名",
  },
  话题讨论标签: {
    话题讨论标签: "话题讨论标签",
    类型: "类型",
    图片: "图片",
    操作: "操作",
    添加标签: "添加标签",
    修改标签: "修改标签",
    选取文件: "选取文件",
  },
  工单标签设置: {
    工单标签设置: "工单标签设置",
    编辑工单标签: "编辑工单标签",
    排序: "排序",
    名称: "名称",
    底纹颜色: "底纹颜色",
    文字颜色: "文字颜色",
    维护人员: "维护人员",
    更新时间: "更新时间",
    操作: "操作",
    新增工单标签: "新增工单标签",
    修改工单标签: "修改工单标签",
  },
  实景标签配置: {
    实景标签配置: "实景标签配置",
    类型: "类型",
    图片: "图片",
    操作: "操作",
    全景: "全景",
    全景链接: "全景链接",
    视频: "视频",
    选取文件: "选取文件",
    全部: "全部",
  },
  //#endregion

  //#region 企业管理
  控制台侧边栏: {
    企业管理: "企业管理",
    项目管理: "项目管理",
    模型管理: "模型管理",
    人员管理: "人员管理",
    操作管理: "操作管理",
  },
  企业管理: {
    企业管理: "企业管理",
    单位简称: "单位简称",
    单位名称: "单位名称",
    企业编码: "企业编码",
    单位类别: "单位类别",
    地址: "地址",
    邮箱: "邮箱",
    电话: "电话",
    网址: "网址",
    项目容量: "项目容量",
    空间容量: "空间容量",
    成员容量: "成员容量",
    授权期限: "授权期限",
    高级授权: "高级授权",
  },
  //#endregion

  //#region 项目管理
  项目管理: {
    项目管理: "项目管理",
    显示全部项目: "显示全部项目",
    序号: "序号",
    项目名称: "项目名称",
    项目简称: "项目简称",
    项目编号: "项目编号",
    BIM负责人: "BIM负责人",
    所属分组: "所属分组",
    项目类型: "项目类型",
    建设单位: "建设单位",
    项目地点: "项目地点",
    创建时间: "创建时间",
    模型: "模型",
    新建项目: "新建项目",
    请输入项目名称: "请输入项目名称",
  },
  新建项目: {
    项目详情: "项目详情",
    新建项目: "新建项目",
    项目编号: "项目编号",
    项目名称: "项目名称",
    BIM负责人: "BIM负责人",
    所属分组: "所属分组",
    项目类型: "项目类型",
    项目简称: "项目简称",
    合同金额: "合同金额",
    BIM耗时: "BIM耗时",
    服务阶段: "服务阶段",
    总体投资: "总体投资",
    项目规模: "项目规模",
    项目地点: "项目地点",
    总体工期: "总体工期",
    建设单位: "建设单位",
    设计单位: "设计单位",
    施工单位: "施工单位",
    监理单位: "监理单位",
    开工竣工: "开工竣工",
    开工日期: "开工日期",
    竣工日期: "竣工日期",
    一次设计: "一次设计",
    深化设计: "深化设计",
    外包设计: "外包设计",
    计划竣工: "计划竣工",
    创建日期: "创建日期",
    项目概括: "项目概括",
    保存: "保存",
    还原: "还原",
    项目照片: "项目照片",
  },
  模型列表: {
    模型列表: "模型列表",
    序号: "序号",
    文件名称: "文件名称",
    专业备注: "专业备注",
    文件大小: "文件大小",
    上传文件大小: "上传文件大小",
    版本备注: "版本备注",
    联系人: "联系人",
    邮箱: "邮箱",
    电话: "电话",
    备注: "备注",
    更新时间: "更新时间",
    操作: "操作",
    请输入模型名称: "请输入模型名称",
    浏览: "浏览",
    卸载: "卸载",
    加载模型: "加载模型",
    模型列表: "模型列表",
    确定加载: "确定加载",
    上传模型: "上传模型",
    更新模型: "更新模型",
    转换记录: "转换记录",
    转换类型: "转换类型",
    用时: "用时",
    创建时间: "创建时间",
    所属项目: "所属项目",
    转换状态: "转换状态",
    转换中: "转换中",
    转换成功: "转换成功",
    转换失败: "转换失败",
    选择上传模型的类型: "选择上传模型的类型",
    上传SVFZIP文件: "上传SVFZIP文件",
    上传RVTNWD文件: "上传RVT/NWD文件",
    通过AUTODESK云端进行轻量化转后的文件:
      "通过AUTODESK云端进行轻量化转后的文件",
    上传REVITNAVISWORKS文件并转化: "上传REVIT/NAVISWORKS文件并转化",
    上传到服务器并进行模型转换时间较长请耐心等待:
      "上传到服务器并进行模型转换,时间较长请耐心等待...",
    模型文件: "模型文件",
    点击上传: "点击上传",
    请选择文件后上传: "请选择文件后上传",
  },
  //#endregion

  //#region 人员管理
  人员管理: {
    人员管理: "人员管理",
    显示全部人员: "显示全部人员",
    请输入用户姓名: "请输入用户姓名",
    导入Excel: "导入Excel",
    职位管理: "职位管理",
    新建: "新建",
    邀请: "邀请",
    导出: "导出",
    点击下载模板文件: "点击下载模板文件",
    并按要求填好后上传: "并按要求填好后上传",
    选择文件: "选择文件",
    上传到服务器: "上传到服务器",
    只能上传xlsx文件: "只能上传xlsx文件",
    新增职位: "新增职位",
    职位名称: "职位名称",
    操作: "操作",
    重命名: "重命名",
    移除: "移除",
    提示: "提示",
    请输入职位名称: "请输入职位名称",
    新建账户信息: "新建账户信息",
    姓名: "姓名",
    账号: "账号",
    手机号: "手机号",
    邮箱: "邮箱 ",
    登录密码: "登录密码",
    重复密码: "重复密码",
    所属组织: "所属组织",
    职位: "职位",
    性别: "性别",
    项目经理: "项目经理",
    项目总工: "项目总工",
    BIM经理: "BIM经理",
    BIM工程师: "BIM工程师",
    BIM负责人: "BIM负责人",
    性别: "性别",
    男: "男",
    女: "女",
    出生年月: "出生年月",
    职称: "职称",
    初级: "初级",
    中级: "中级",
    副高级: "副高级",
    高级: "高级",
    学历: "学历",
    毕业院校: "毕业院校",
    联系地址: "联系地址",
    输入邀请账户信息: "输入邀请账户信息",
    账号手机号邮箱: "账号",
    部门: "部门",
    职位: "职位",
    邀请: "邀请",
    启用禁用: "启用禁用",
    到期时间: "到期时间",
    查看: "查看",
    机构组织: "机构组织",
    担任职位: "担任职位",
    管理的项目: "管理的项目",
    参与的项目: "参与的项目",
    项目编号: "项目编号",
    项目简称: "项目简称",
    岗位: "岗位",
    序号: "序号",
    创建日期: "创建日期",
    查看用户详情: "查看用户详情",
    选择到期时间: "选择到期时间",
    不选则为永久有效: "不选则为永久有效 ",
    此操作会将此人移除该公司是否继续: "此操作会将此人移除该公司, 是否继续?",
  },
  //#endregion

  //#region 操作列表
  操作列表: {
    操作列表: "操作列表",
    用户姓名: "用户姓名",
    开始日期: "开始日期",
    结束日期: "结束日期",
    操作内容: "操作内容",
    查询: "查询",
    删除记录: "删除记录",
    用户姓名: "用户姓名",
    账户: "账户",
    操作模块: "操作模块",
    操作时间: "操作时间",
  },
  //#endregion

  //#region 个人中心
  personcenter: {
    个人中心: "个人中心",
    修改密码: "修改密码",
    加入企业: "加入企业",
    退出登录: "退出登录",
    消息通知: "消息通知",
    单位名称: "单位名称",
    单位类别: "单位类别",
    邮箱: "邮箱",
    联系地址: "联系地址",
    电话: "电话",
    网址: "网址",
    姓名: "姓名",
    性别: "性别",
    男: "男",
    女: "女",
    账户: "账户",
    出生年月: "出生年月",
    地址: "地址",
    职称: "职称",
    学历: "学历",
    手机号: "手机号",
    更换手机号: "更换手机号",
    修改密码: "修改密码",
    旧密码: "旧密码",
    新密码: "新密码",
    确认密码: "确认密码",
  },
  //#endregion

  //#region 通用
  common: {
    暂不支持查看该类型文件: "暂不支持查看该类型文件",
    同意询问: "确定同意吗？",
    删除询问: "确定要删除吗？",
    拒绝询问: "确定要拒绝吗？",
    同意: "同意",
    拒绝: "拒绝",
    删除: "删除",
    确定: "确定",
    取消: "取消",
    添加: "添加",
    请填写必填项: "请填写必填项！",
    请选择数据: "请选择数据",
    处理成功: "处理成功！",
    处理失败: "处理失败！",
    账户已存在: "账户已存在！",
    修改: "修改",
    删除: "删除",
    操作: "操作",
    提示: "提示",
    新建节点: "新建节点",
    请选择文件后上传: "请选择文件后上传！",
    请先选择: "请先选择",
    请输入内容: "请输入内容",
    只能选择一个: "只能选择一个",
    至少保留一个: "至少保留一个",
    上传类型错误: "上传类型错误！",
    当前用户在此项目中未设置角色请联系管理员:
      "当前用户在此项目中未设置角色，请联系管理员！",
    创建批注: "创建批注",
    批注列表: "批注列表",
    添加批注: "添加批注",
    问题描述: "问题描述",
    问题截图: "问题截图",
    审图要点: "审图要点",
    文件关联: "文件关联",
    本地上传: "本地上传",
    问题类型: "问题类型",
    专业: "专业",
    修改方: "修改方",
    位置: "位置",
    清空: "清空",
    创建: "创建",
    创建时间: "创建时间",
    请输入搜索内容: "请输入搜索内容",
    发表回复: "发表回复",
    所属文件: "所属文件",
    问题状态: "问题状态",
    创建人: "创建人",
    状态: "状态",
    内容: "内容",
    图片预览: "图片预览",
    请先进行模型转换: "请先进行模型转换！",
    转换成功: "转换成功！",
    转换失败: "转换失败！",
    转换中: "转换中",
    关闭: "关闭",
    最大化: "最大化",
    最小化: "最小化",
    批注详情: "批注详情",
    活动: "活动",
    涂鸦: "批注"
  },
  //#endregion

  //#region 超级管理员
  superAdmin: {},
  //#endregion

  //#region 侧边菜单栏
  xmzycbl: {
    projectHome: "项目主页",
    ApplicationNavigation: "应用导航",
    DirectoryOfCommunications: "通讯目录",
    ListOfannotations: "批注列表",
    ProjectData: "项目资料",
    PersonalData: "个人资料",
    ProgressDisplay: "进度展示",
    EngineeringDynamic: "工程动态",
    DiscussTheTopic: "话题讨论",
    WorkOrderTask: "工单任务",
    RealScenicSpot: "实景点位",
  },
  //#endregion

  //#region 项目主页
  xmzy: {
    ProjectDetails: "项目详情",
    ProjectName: "项目名称",
    ProjectNumber: "项目编号",
    StartDate: "开工日期",
    ScheduledToBeCompleted: "计划竣工",
    ProjectManager: "项目经理",
    Overallconstructionperiod: "总体工期",
    ConsultingContracts: "咨询合同",
    OverallInvestment: "总投资",
    Projectaddress: "项目地址",
    ProjectNotice: "项目通知",
    Todotasks: "待办任务",
    DataDynamics: "资料动态",
    Formtodo: "表单待办",
    Progresstobedone: "进度待办",
    Workorderpending: "工单待办",
    Workdynamics: "工作动态",
    无标题: "无标题",
    项目通知: "项目通知",
    内容: "内容",
  },
  //#endregion

  //#region 通讯目录
  txml: {
    NewsletterDirectory: "通讯目录",
    显示全部成员: "显示全部成员",
    序号: "序号",
    账号: "账号",
    姓名: "姓名",
    所属组织: "所属组织",
    岗位: "岗位",
    邮箱: "邮箱",
    手机号: "手机号",
  },
  //#endregion

  //#region 批注列表
  pzlb: {
    批注列表: "批注列表",
    关联文件: "关联文件",
    专业: "专业",
    问题分类: "问题分类",
    状态: "状态",
    描述: "描述",
    修改方: "修改方",
    创建人: "创建人",
    创建时间: "创建时间",
    操作: "操作",
    请输入关键字进行搜索: "请输入关键字进行搜索",
    详情: "详情",
    打开: "打开",
    删除: "删除",
    问题回复: "问题回复",
    待修改: "待修改",
    已修改: "已修改",
    不修改: "不修改",
    已销项: "已销项",
    发表回复: "发表回复",
    内容: "内容",
    所属文件: "所属文件",
    问题状态: "问题状态",
    问题描述: "问题描述",
    审图要点: "审图要点",
    问题类型: "问题类型",
    位置: "位置",
    活动: "活动",
    请输入回复内容最多可输入200字: "请输入回复内容,最多可输入200字",
    其他: "其他",
    图面问题: "图面问题",
    图纸缺失: "图纸缺失",
    图纸不一致: "图纸不一致",
    净高问题: "净高问题",
    碰撞问题: "碰撞问题",
    预留洞口: "预留洞口",
    设计优化: "设计优化",
    项目管理: "项目管理",
    总图: "总图",
    建筑: "建筑",
    结构: "结构",
    给排水: "给排水",
    暖通: "暖通",
    电气: "电气",
    人防: "人防",
    智能化: "智能化",
    BIM: "BIM",
    装配式: "装配式",
    景观: "景观",
    精装: "精装",
    规划: "规划",
    经济: "经济",
    钢结构: "钢结构",
    综合机电: "综合机电",
    幕墙: "幕墙",
    打开当前浏览器在地址栏输入: "打开当前浏览器，在地址栏输入：",
    复制地址: "复制地址",
    在打开的界面中下拉框选择enabled地址填写你的项目访问路径: "在打开的界面中，下拉框选择enabled，地址填写你的项目访问路径",
    复制访问路径: "复制访问路径",
    点击截图自动上传: "点击截图自动上传",
  },
  //#endregion

  //#region 项目资料
  xmzl: {
    项目资料: "项目资料",
    请选择文件类型: "请选择文件类型",
    请选择标签: "请选择标签",
    请输入文件名称关键词: "请输入文件名称关键词",
    全部: "全部",
    我上传的: "我上传的",
    我收藏的: "我收藏的",
    分享: "分享",
    分享管理: "分享管理",
    删除: "删除",
    序号: "序号",
    文件名称: "文件名称",
    剩余天数: "剩余天数",
    操作: "操作",
    复制链接: "复制链接",
    取消分享: "取消分享",
    大小mb: "大小(MB)",
    文件类型: "文件类型",
    标签: "标签",
    上传时间: "上传时间",
    上传用户: "上传用户",
    可见范围: "可见范围",
    收藏: "收藏",
    取消收藏: "取消收藏",
    修改: "修改",
    下载: "下载",
    公开: "公开",
    半公开: "半公开",
    标签设置: "标签设置",
    可见设置: "可见设置",
    添加可见人员: "添加可见人员",
    根目录: "根目录",
    请选择: "请选择",
    新增资料: "新增资料",
    点击转换: "点击转换",
    转换中请稍等: "转换中请稍等",
    未转换: "未转换",
    转换中: "转换中",
    转换失败: "转换失败",
    转换成功: "转换成功",
    选取文件: "选取文件",
    上传: "上传",
    取消: "取消",
    请选择人员: "请选择人员",
    请输入名称: "请输入名称",
    确定: "确定",
    账号: "账号",
    姓名: "姓名",
    分享资料: "分享资料",
    1: "1天",
    7: "7天",
    30: "30天",
    永久有限: "永久有限",
    移动分组: "移动分组",
    名称: "名称",
    部分可见: "部分可见",
    请先做选择: "请先做选择",
    修改可见: "修改可见",
    选择标签: "选择标签",
    上传文件: "上传文件",
    选择文件夹: "选择文件夹",
  },
  //#endregion

  //#region 我的资料
  我的资料: {
    我的资料: "我的资料",
    请选择文件类型: "请选择文件类型",
    请选择标签: "请选择标签",
    请输入文件名称关键词: "请输入文件名称关键词",
    全部: "全部",
    我上传的: "我上传的",
    我收藏的: "我收藏的",
    分享: "分享",
    分享管理: "分享管理",
    删除: "删除",
    序号: "序号",
    文件名称: "文件名称",
    剩余天数: "剩余天数",
    操作: "操作",
    复制链接: "复制链接",
    取消分享: "取消分享",
    大小mb: "大小(MB)",
    文件类型: "文件类型",
    标签: "标签",
    上传时间: "上传时间",
    上传用户: "上传用户",
    可见范围: "可见范围",
    收藏: "收藏",
    取消收藏: "取消收藏",
    修改: "修改",
    下载: "下载",
    公开: "公开",
    半公开: "半公开",
    标签设置: "标签设置",
    可见设置: "可见设置",
    添加可见人员: "添加可见人员",
    根目录: "根目录",
    请选择: "请选择",
    新增资料: "新增资料",
    点击转换: "点击转换",
    转换中请稍等: "转换中请稍等",
    未转换: "未转换",
    转换中: "转换中",
    转换失败: "转换失败",
    转换成功: "转换成功",
    选取文件: "选取文件",
    上传: "上传",
    取消: "取消",
    请选择人员: "请选择人员",
    请输入名称: "请输入名称",
    确定: "确定",
    账号: "账号",
    姓名: "姓名",
    分享资料: "分享资料",
    永久有限: "永久有限",
    移动分组: "移动分组",
    名称: "名称",
    部分可见: "部分可见",
    请先做选择: "请先做选择",
    批量删除: "批量删除",
    批量移动: "批量移动",
    批量下载: "批量下载",
    新增资料: "新增资料",
    移动: "移动",
    资料预览: "资料预览",
    管理个人审核模块: "管理个人审核模块",
    确认并提交审核: "确认并提交审核",
    选择审批模块: "选择审批模块",
    试试搜索: "试试搜索",
    流程节点: "流程节点",
    审批人: "审批人",
    审批性质: "审批性质",
    个人预定义审核流程模板管理: "个人预定义审核流程模板管理",
    新建: "新建",
    流程环节详情: "流程环节详情",
    审核名称: "审核名称",
    立即创建: "立即创建",
    驳回信息: "驳回信息",
    时间: "时间",
    内容: "内容",
    成功: "成功",
    失败: "失败",
    请勾选报审资料: "请勾选报审资料",
    请先选择: "请先选择",
    是否移动该资料: "是否移动该资料?",
    提示: "提示",
    新建文件夹: "新建文件夹",
    上传: "上传",
    文件: "文件",
    文件夹: "文件夹",
    移动到: "移动到",
    文件大小: "文件大小",
    更新时间: "更新时间",
    状态: "状态",
    请输入文件夹名称: "请输入文件夹名称",
    文件夹名称不符合规范: "名称不符合规范！允许：中文、英文、数字、下划线(_)、短横线(-)、空格、点(.)",
    文件夹重复: "文件夹重复",
    上传中: "上传中",
    上传成功: "上传成功",
    上传失败: "上传失败",
    不能移动到当前目录下: "不能移动到当前目录下",
    选择文件移动时必须选择目标文件夹: "选择文件移动时必须选择目标文件夹",
    移动失败当前目录下已有此名称: "移动失败，当前目录下已有此名称",
    回收站: "回收站",
    高级查询: "高级查询",
    修改人: "修改人",
    还原: "还原",
    上传列表: "上传列表",
    列表: "列表",
    宫格: "宫格",
    请选择文件夹: "请选择文件夹",
    根目录只能上传文件夹: "根目录只能上传文件夹",

  },
  //#endregion

  //#region 进度展示
  进度展示: {
    高级筛选: "高级筛选",
    模型选择: "模型选择",
    取消全选: "取消全选",
    全选: "全选",
    添加: "添加",
    修改: "修改",
    删除: "删除",
    名称: "名称",
    请输入名称: "请输入名称",
    状态: "状态",
    请选择状态: "请选择状态",
    提交: "提交",
    初始化模型数据中: "初始化模型数据中...",
    筛选条件: "筛选条件",
    并且: "并且",
    或者: "或者",
    大于: "大于",
    小于: "小于",
    等于: "等于",
    包含: "包含",
    立即查询: "立即查询",
    筛选范围: "筛选范围",
    当前选择构件: "当前选择构件",
    无选择则以全模型: "无选择则以全模型",
    刷新数据: "刷新数据",
    请填写完整筛选条件: "请填写完整筛选条件",
    一共查找出: "一共查找出",
    暂无符合条件的构件: "暂无符合条件的构件",
    初始化: "初始化",
    个构件: "个构件",
    请填写节点名称: "请填写节点名称!",
    成功: "成功",
    失败: "失败",
    当前项目未设置进度状态: "当前项目未设置进度状态",
  },
  //#endregion

  //#region 工程动态
  工程动态: {
    工程动态: "工程动态",
    至: "至",
    开始日期: "开始日期",
    结束日期: "结束日期",
    请选择动态标签: "请选择动态标签",
    请选择分类: "请选择分类",
    发布动态: "发布动态",
    动态: "动态",
    请输入标题: "请输入标题",
    请选择分类: "请选择分类",
    选择日期时间: "选择日期时间",
    确定: "确 定",
    取消: "取 消",
    最近一周: "最近一周",
    最近一月: "最近一月",
    最近三月: "最近三月",
    公开: "公开",
    私人: "私人",
    成功: "成功",
    失败: "失败",
    请选择时间: "请选择时间",
    请输入标题: "请输入标题",
    请输入内容: "请输入内容",
  },
  //#endregion

  //#region 话题讨论
  话题讨论: {},
  //#endregion

  //#region 工单任务
  工单任务: {
    工单任务: "工单任务",
    序号: "序号",
    任务名称: "任务名称",
    发起人: "发起人",
    计划完成时间: "计划完成时间",
    执行人: "执行人",
    验收截止时间: "验收截止时间",
    验收人: "验收人",
    进度: "进度",
    状态: "状态",
    标签: "标签",
    操作: "操作",
    请输入任务名称: "请输入任务名称",
    我发起的: "我发起的",
    我执行的: "我执行的",
    我审批的: "我审批的",
    发起任务: "发起任务",
    执行人员: "执行人员",
    部门: "部门",
    姓名: "姓名",
    任务内容: "任务内容",
    工作时间: "工作时间",
    工单标签: "工单标签",
    重要程度: "重要程度",
    紧急程度: "紧急程度",
    审核人员: "审核人员",
    关联模型: "关联模型",
    关联资料: "关联资料",
    截止时间: "截止时间",
    确定关联: "确定关联",
    确定: "确 定",
    取消: "取 消",
    显示全部文件: "显示全部文件",
    请输入文件名: "请输入文件名",
    名字: "名字",
    选择集: "选择集",
    视点: "视点",
    催办: "催办",
    删除: "删除",
    启动: "启动",
    验收: "验收",
    项目团队人员: "项目团队人员",
    请输入用户姓名: "请输入用户姓名",
    至: "至",
    开始日期: "开始日期",
    结束日期: "结束日期",
    请选择: "请选择",
    选择日期时间: "选择日期时间",
    任务进度: "任务进度",
    调节进度: "调节进度",
    请输入内容: "请输入内容",
    成果说明: "成果说明",
    附件: "附件",
    发送: "发送",
    申请审核: "申请审核",
    审核验收: "审核验收",
    验收意见: "验收意见",
    通过: "通过",
    不通过: "不通过",
    任务详情: "任务详情",
    添加: "添加",
    截图: "截图",
    查看: "查看",
    名称: "名称",
    新增: "新增",
    时间范围: "时间范围",
    时间: "时间",
    内容: "内容",
    验收完成: "验收完成",
    请选择类型: "请选择类型",
    输入关键字: "输入关键字",
    新增资料: "新增资料",
    选取文件: "选取文件",
    公开: "公开",
    半公开: "半公开",
    可见设置: "可见设置",
    上传: "上传",
    请选择人员: "请选择人员",
    请输入名称: "请输入名称",
    账号: "账号",
    成功: "成功",
    失败: "失败",
    此节点未绑定数据或数据丢失: "此节点未绑定数据或数据丢失",
    只可选择单模: "只可选择单模",
    未选择执行任务人员: "未选择执行任务人员",
    成功发布: "成功发布",
    个工单: "个工单",
    是否撤销该工单任务: "是否撤销该工单任务",
    催办成功: "催办成功",
    已催办待执行: "已催办,待执行",
    启动成功: "启动成功",
    申请审核成功: "申请审核成功",
    成功发布: "成功发布",
    个工单: "个工单",
    上传文件大小不能超过500MB: "上传文件大小不能超过500MB!",
    当前限制选择1个文件本次选择了: "当前限制选择 1 个文件,本次选择了",
    个文件: "个文件,",
    共选择了: "共选择了",
    确定移除: "确定移除",
  },
  //#endregion

  //#region 实景点位
  实景点位: {
    视点保存: "视点保存",
    请输入搜索内容: "请输入搜索内容...",
    涂鸦: "涂鸦",
    保存: "保存",
    分享: "分享",
    发起碰撞: "发起碰撞",
    新建视点目录: "新建视点目录",
    重命名: "重命名",
    删除: "删除",
    过滤器: "过滤器",
    框选集: "框选集",
    增加: "增加",
    反选: "反选",
    收藏: "收藏",
    新建目录: "新建目录",
    名称: "名称",
    地点: "地点",
    拍摄时间: "拍摄时间",
    类型: "类型",
    是否全景图: "是否全景图",
    是: "是",
    否: "否",
    文件: "文件",
    选择文件: "选择文件",
    全景链接: "全景链接",
    提交: "提交",
    添加分组: "添加分组",
    请选择: "请选择",
    请输入名称: "请输入名称",
    序号: "序号",
    名称: "名称",
    绑定: "绑定",
    解绑: "解绑",
    选择关联文档: "选择关联文档",
    全部: "全部",
    照片: "照片",
    视频: "视频",
    上传用户: "上传用户",
    上传时间: "上传时间",
    确认关联: "确认关联",
    参数: "参数",
    条件: "条件",
    请选择筛选条件: "请选择筛选条件",
    值: "值",
    资源类型: "资源类型",
    关联: "关联",
    此节点未绑定数据或数据丢失: "此节点未绑定数据或数据丢失",
    标签: "标签",
    全景图片: "全景图片",
    图片: "图片",
    导出工程量: "导出工程量",
    高级选项: "高级选项",
    参数: "参数",
    条件: "条件",
    创建人: "创建人",
    操作: "操作",
    发起话题讨论: "发起话题讨论",
    取消: "取 消",
    确定: "确 定",
    分类: "分类",
    用户: "用户",
  },
  //#endregion


  //#region 排序
  排序: {
    名称: "名称",
    时间: "时间",
    类型: "类型",
    大小: "大小",
  },
  //#endregion


};
